/**
 * Modal view ID of the SharedDocument view.
 */
export const SHARE_DOCUMENT_VIEW_ID = 'SHARE_DOCUMENT_VIEW_ID';
